<mat-dialog-content class="modal-content">
  <div class="modal-header">
    <h2>Date Range</h2>
    <button mat-icon-button class="close-button" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <hr class="divider" />

  <div class="custom-date-range-select">
    <mat-form-field appearance="outline">
      <mat-select [(ngModel)]="selectedDropdown" (ngModelChange)="onDropdownChange($event)">
        <mat-option value="Last 7 Days">Last 7 Days</mat-option>
        <mat-option value="Last 30 Days">Last 30 Days</mat-option>
        <mat-option value="Last 90 Days">Last 90 Days</mat-option>
        <mat-option value="Last 6 Months">Last 6 Months</mat-option>
        <mat-option value="Last 12 Months">Last 12 Months</mat-option>
        <mat-option value="Month to Date">Month to Date</mat-option>
        <mat-option value="Quarter to Date">Quarter to Date</mat-option>
        <mat-option value="Year to Date">Year to Date</mat-option>
        <mat-option value="All Dates">All Dates</mat-option>
        <mat-option value="Custom">Custom</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="date-range-text-boxes">
    <div class="input-container">
      <mat-form-field appearance="outline">
        <mat-label>mm/dd/yyyy</mat-label>
        <mat-icon matPrefix>calendar_month</mat-icon>
        <input matInput [matDatepicker]="startDatePicker"
               (dateChange)="handleStartDateChange($event)"
               (focus)="startDatePicker.open()"
               [(ngModel)]="startDate">
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <span class="custom-divider-for-dates">to</span>
    <div class="input-container">
      <mat-form-field appearance="outline">
        <mat-label>mm/dd/yyyy</mat-label>
        <mat-icon matPrefix>calendar_month</mat-icon>
        <input matInput [matDatepicker]="endDatePicker"
               (dateChange)="handleEndDateChange($event)"
               (focus)="endDatePicker.open()"
               [(ngModel)]="endDate">
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <hr class="divider" />

  <mat-dialog-actions>
    <button mat-button (click)="onClear()" mat-dialog-close style="margin-right: auto;" class="clear-button">
      <mat-icon>block</mat-icon>
      Clear All
    </button>
    <ng-container *ngTemplateOutlet="applyButton"></ng-container>
    <ng-template #applyButton>
      <app-button mat-button
                  (click)="onApply()"
                  [label]="'Apply'"
                  [icon]="'check_circle_outline'"
                  [isIcon]="false"></app-button>
    </ng-template>
  </mat-dialog-actions>
</mat-dialog-content>
